<template>
  <div >
     <b-button  class="viewbuttom" >مشاهده دوره ها  <b-icon icon="arrow-left-right" class="mr-4"></b-icon></b-button>
  </div>
           




</template>

<script>
    export default{
        name: "Bt600",
    };

</script>


<style scoped>

.viewbuttom{
    height: 4rem;
    background-color: red;
}


.viewbuttom:hover  {
    background-color: rgb(5, 87, 59);
    transition: width 0.5s;
}

</style>